import {isEmpty, map} from 'lodash'
import TableFilters from '@/components/component/Reuse/TableFilters/TableFilters.vue'
export default {
    name: 'Table',
    components: {
        BulkUpdate: () => import(/* webpackChunkName: "group-admin" */'@/components/component/TestAdmin/BulkUpdate/BulkUpdate.vue'), 
        TableFilters},
    props: {
        columns: {
            type: Array,
            required: true
        },
        tableOptions: {
            type: Object,
            default: () =>{}
        },
        tableData: {
            type: Array,
            default: []
        },
        type: {
            type: String,
        },
        changePage: {
            type: Function
        },
        changeRecord: {
            type: Function
        },
        totaltableData: {
            type: Number,
            default: 1
        },
        currentPage: {
            type: Number
        },
        selectedValue:{
            type:Number
        },
        clear:{
            type: Boolean,
            default: false
        },
        sorting: {
            type: Function
        },
        handleCommand: {
            type: Function
        },
        tableType: {
            type: String,
            default: ''
        },
        selectedTableFilters: {
            type: Object,
            default: () => {}
        },
        setTableFilters : {
            type: Function,
            default: () => {}
        },
        applyFilters: {
            type: Function,
            default: () => {}
        },
        showBulkUpdate: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        category () {
            return this.$store.getters.getType
        }
    },
    watch: {
        totaltableData (value) {
            this.totalPage = value
        },
        currentPage (value) {
            this.current = value
        },
        selectedValue (value) {
            this.selected = value
        },
        tableData (value) {
            this.rowsData = value
        },
        selectedTableFilters (value) {
            this.tableFilters = value
        }
    },
    data () {
        return {
            defaultProps: {
                columns: [],
                tableData: [],
                options: {}
              },
              totalPage: 0,
              current: 0,
              selected: 10,
              isAllMarked: false,
              allMarked: false,
              markedRows: [],
              isEmpty,
              isBulkEdit: false,
              rowsData: [],
              sort: true,
              sortingKey: 'name',
              sortingOrder: 'desc',
              cityFilter: false,
              filterData: [],
              nameFilterData: [],
              cityFilterData: [],
              citySearch: '',
              tableFilters: {},
        }
    },
    methods: {
        getAuthors (authors) {
            if(authors && authors.length <= 0) return ''
            let unique = [...new Set(authors.map(item => item.name && item.name))]
            return unique.join(', ')
          },
          getPublisher (publisher) {
              if (isEmpty(publisher)) return ''
              return publisher.name
          },
          getPublicationsName (publicationArray) {
            let publicationName = []
            if (!isEmpty(publicationArray)) map(publicationArray, (publication) => { publicationName.push(publication.name) })
            return publicationName.join(', ');
            },    
          editArticle(item){
              let type = 'Publications'
              switch (type) {
                case 'Articles':
                        this.$router.push({name: `editArticles`, params: {id: item}})
                    break
                    case 'Authors':
                        this.$router.push({name: `editAuthors`, params: {id: item}})
                    break
                    case 'Publishers':
                        this.$router.push({name: `editPublishers`, params: {id: item}})
                    break
                    case 'Publications':
                        this.$router.push({name: `editPublications`, params: {id: item}})
                    break

              }
              
          },
          toggleSingleItem(id) {
              if (!this.markedRows.includes(id)) {
                this.markedRows.push(id)
             } else {
                 const index = this.markedRows.indexOf(id)
                 if (index > -1) {
                 this.markedRows.splice(index, 1);
                 }
             }
		},
		toggleAll (event) {
            if (!this.showBulkUpdate) return
            this.markedRows = []
            this.allMarked = event
            this.markedRows = this.allMarked?this.$refs.table.data.map(row=>row._id):[]       
           if(!isEmpty(this.markedRows)) {
            this.markedRows = this.markedRows.filter((item,index)=>{
                if(index< this.selected) return item
            })
           }
        }, 
        bulkEdit () {
            this.isBulkEdit = true
            this.$store.dispatch('setDialog', true)
        },
        clearFields() {
            this.markedRows = []
        },
        changeSort (sortingKey) {
            this.sortingOrder = this.sortingKey !== sortingKey ? 'desc' : this.sortingOrder === 'desc' ? 'asc' : 'desc'
            this.sortingKey = sortingKey
            this.sorting(this.category, this.sortingOrder, this.sortingKey) 
        },
        refreshPage () {
            this.clearFields()
            // this.changePage(this.current)
            this.$emit('refreshPage')
        },
        getPublication(publication){
            return publication && publication.name ? publication.name : ''
        },
        testButton () {
            this.markedRows = []
            this.isAllMarked = false
            this.isBulkEdit = false
        },
        getDate (date) {
            if (date !== undefined && date !== null) {
              let d = new Date(date)
              return ('0' + d.getDate()).slice(-2) + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' +
                d.getFullYear() + ' ' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2)
            }
        },
        getPublicationUrl (url) {
            if (isEmpty(url)) return ''
            let unique = [...new Set(url.map(item => item))]
            return unique.join(', ')
        }
    }
}